import moment from "moment";
import { getObjectKeyByValue, hasOwn } from "../utility/utility";
import trackingEventDictionary from "../dictionary/tracking-event";
import { trademoTrackingEvents } from "./trademo-tracking";
import { countryTypeDictionary, trackingPlanEnum, redirectionInCountryDictionary as redirectionTypeEnum, filterTypeDictionary as filterTypeEnum, categoryName as categoryName, filterTypeDictionary as filterType, redirectionTypePayload } from "./global-country-dictionary";
import { globalCountryDetailsDictionary } from "./global-country-details";
import { showNoDollar } from "@utils/enum";
import { getTitleCase, multiplyIdentifier } from "@utils/utils";
import LocalStorageService from "@core/services/local-storage.service";
import { profileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import commaFormat from "@utils/commaFormat";
const localStorageService = LocalStorageService.getService();

// Below code is used for Getting the Initials from the String
export const getInitials = (string) => {
  if (string) {
    let names = string.split(" "),
      initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  }
};
// End of the above code
export const getCompanyComingFrom = function (data) {
  return !!data && (data.toUpperCase() === "I" || data.toUpperCase() === "IMPORTER" || data.toUpperCase() === "IMPORT") ? "I" : "E";
};
export const printValueChecker = function (data, keyObj) {
  let value = "";
  for (let property in keyObj) {
    if (data[keyObj[property].key]) {
      if (typeof data[keyObj[property].key] === "boolean") {
        value = keyObj[property].key;
        break;
      } else {
        value = data[keyObj[property].key];
        break;
      }
    }
  }
  if (value !== "") {
    value = keyObj.fallback;
  }
  return value;
};
export const hsCodeFormatter = function (data) {
  if (!data || !Array.isArray(data)) return;
  let temphs = "";
  data.forEach((item, index) => {
    if (!!item && !!item.hscode && item.hscode !== "") {
      if (index !== data.length - 1) {
        temphs = temphs + item.hscode + " | ";
      } else {
        temphs = temphs + item.hscode;
      }
    }
  });
  return temphs;
};
export const commaFormaterFixed = function (nStr) {
  nStr += "";
  let x = nStr.split(".");
  let x1 = x[0];
  let x2 = x.length > 1 ? "." + x[1] : "";
  let rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "," + "$2");
  }
  return x1 + x2;
};
export const productKeywordsFormatter = function (data) {
  return data.join(" | ");
};
export const getDefaultSortValue = function (data) {
  let finalValue = "";
  for (let i = 0; i < data.length; i++) {
    if (data[i].isDefault === true) {
      finalValue = data[i];
    }
  }
  return finalValue;
};
export const getTeuFilterList = function (data) {
  let tempArr = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].type === filterTypeEnum.teuFilter) {
      tempArr.push(data[i].key);
    }
  }
  return tempArr;
};
export const getUpgradeCheckboxFilterList = function (data) {
  let tempArr = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].type === filterTypeEnum.upgradeCheckboxFilter) {
      tempArr.push(data[i].key);
    }
  }
  return tempArr;
};
export const getWeightFilterList = function (data) {
  let tempArr = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].type === filterTypeEnum.weightFilter) {
      tempArr.push(data[i].key);
    }
  }
  return tempArr;
};
export const getRangeFilterList = function (data) {
  let tempArr = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].type === filterTypeEnum.rangeFilter) {
      tempArr.push(data[i].key);
    }
  }
  return tempArr;
};
export const getBoxFilterList = function (data) {
  let tempArr = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].type === filterTypeEnum.boxFilter) {
      tempArr.push(data[i].key);
    }
  }
  return tempArr;
};
export const getProximityFilterList = function (data) {
  let tempArr = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].type === filterTypeEnum.proximityFilter) {
      tempArr.push(data[i].key);
    }
  }
  return tempArr;
};
export const getLocalizeFilterList = function (data) {
  let tempArr = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].type === filterTypeEnum.localizeFilter) {
      tempArr.push(data[i].key);
    }
  }
  return tempArr;
};
export const getLocalizeFilterAlternateKeyObject = function (data) {
  let tempObj = {};
  for (let i = 0; i < data.length; i++) {
    if (data[i].type === filterTypeEnum.localizeFilter) {
      tempObj[data[i].altKey] = data[i].key;
    }
  }
  return tempObj;
};
export const getSliderFilterList = function (data) {
  let tempArr = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].type === filterTypeEnum.sliderFilter) {
      tempArr.push(data[i].key);
    }
  }
  return tempArr;
};
export const getRadioFilterList = function (data) {
  let tempArr = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].type === filterTypeEnum.radioFilter) {
      tempArr.push(data[i].key);
    }
  }
  return tempArr;
};
export const getNormalFilterList = function (data) {
  let tempArr = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].type === filterTypeEnum.normalFilter) {
      tempArr.push(data[i].key);
    }
  }
  return tempArr;
};
export const getHSCodeFilterList = function (data) {
  let tempArr = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].type === filterTypeEnum.hsCodeFilter) {
      tempArr.push(data[i].key);
    }
  }
  return tempArr;
};

export const mapWeightFiltersArray = function (data) {
  let filterArr = [];
  if (data.length > 0) {
    data.map((item) => {
      if (item.isChecked === true) {
        if (item.key === "upto 1,000 Kg" || item.key === "upto 1000 Kg" || item.key === "upto USD 1,000") {
          filterArr.push("0-1000");
        } else if (item.key === "1,000-10,000 Kg" || item.key === "1000-10000 Kg" || item.key === "USD 1,000-10,000") {
          filterArr.push("1000-10000");
        } else if (item.key === "10,000-1,00,000 Kg" || item.key === "10000-100000 Kg" || item.key === "USD 10,000-1,00,000") {
          filterArr.push("10000-100000");
        } else if (item.key === "1,00,000-1,00,00,000 Kg" || item.key === "100000-10000000 Kg" || item.key === "USD 1,00,000-1,00,00,000") {
          filterArr.push("100000-10000000");
        } else if (item.key === "USD 1,00,00,000-1,00,00,00,000") {
          filterArr.push("10000000-1000000000");
        } else {
          filterArr = [];
        }
      }
    });
  }
  return filterArr;
};

export const mapTeuFiltersArray = function (data) {
  let filterArr = [];
  if (data.length > 0) {
    data.map((item) => {
      if (item.isChecked === true) {
        if (item.key === "Less than 1") {
          filterArr.push("0-1");
        } else if (item.key === "Between 1 to 2") {
          filterArr.push("1-2");
        } else if (item.key === "Between 2 to 3") {
          filterArr.push("2-3");
        } else if (item.key === "Between 3 to 4") {
          filterArr.push("3-4");
        } else if (item.key === "Above 4") {
          filterArr.push("4-200");
        }
      }
    });
  }
  return filterArr;
};
export const mapReloadWeightFiltersArray = function (data) {
  let filterArr = [];
  if (data.length > 0) {
    data.map((item) => {
      if (item === "upto 1,000 Kg" || item === "upto 1000 Kg") {
        filterArr.push("0-1000");
      } else if (item === "1,000-10,000 Kg" || item === "1000-10000 Kg") {
        filterArr.push("1000-10000");
      } else if (item === "10,000-1,00,000 Kg" || item === "10000-100000 Kg") {
        filterArr.push("10000-100000");
      } else if (item === "1,00,000-1,00,00,000 Kg" || item === "100000-10000000 Kg") {
        filterArr.push("100000-10000000");
      } else {
        filterArr = [];
      }
    });
  }
  return filterArr;
};
export const mapReloadTeuFiltersArray = function (data) {
  let filterArr = [];
  if (data.length > 0) {
    data.map((item) => {
      if (item === "Less than 1") {
        filterArr.push("0-1");
      } else if (item === "Between 1 to 2") {
        filterArr.push("1-2");
      } else if (item === "Between 2 to 3") {
        filterArr.push("2-3");
      } else if (item === "Between 3 to 4") {
        filterArr.push("3-4");
      } else if (item === "Above 4") {
        filterArr.push("4-200");
      }
    });
  }
  return filterArr;
};
// minShipmentValue,this.state.maxShipmentValue,this.state.shipmentChanged
export const mapFiltersArray = function (data) {
  let filterArr = [];
  if (!!data && data.length > 0) {
    data.map((item) => {
      if (item.isChecked === true) {
        filterArr.push(item.key);
      }
    });
  }
  return filterArr;
};
export const mapSearchToDate = function (contryType, searchString, userCredit, fromAcutalArrivalDate, date) {
  let tempDate = null;
  if (new URLSearchParams(searchString).get("redirectingFrom") === redirectionTypeEnum.companyProfile && userCredit) {
    tempDate = !!contryType && contryType.toLowerCase() === countryTypeDictionary.import.toLowerCase() ? moment(userCredit.searchToDate).toDate() : moment(userCredit.searchToDateExports).toDate();
  } else if (new URLSearchParams(searchString).get("comingFrom") === redirectionTypeEnum.email) {
    tempDate = fromAcutalArrivalDate;
  } else {
    tempDate = moment(date).toDate();
  }
  return tempDate;
};
export const mapSearchFromDate = function (contryType, searchString, userCredit, fromActualArrivalDate, orignalFromDate) {
  let tempDate = null;
  if (userCredit) {
    if (contryType.toLowerCase() === countryTypeDictionary.import.toLowerCase()) {
      if (userCredit.user_active_plan.includes("advanced") || userCredit.user_active_plan.includes("pro") || userCredit.user_active_plan.includes("starter")) {
        tempDate = moment(userCredit.searchFromDate).toDate();
      } else {
        tempDate = userCredit && userCredit.defaultSearchFromDateImport && !window.location.href.includes("all-country-shipments") && !window.location.href.includes("global-search") ? moment(userCredit.defaultSearchFromDateImport).toDate() : moment(userCredit.defaultSearchFromDate).toDate();
      }
    } else {
      if (userCredit.user_active_plan.includes("advanced") || userCredit.user_active_plan.includes("pro") || userCredit.user_active_plan.includes("starter")) {
        tempDate = moment(userCredit.searchFromDate).toDate();
      } else {
        tempDate = userCredit && userCredit.defaultSearchFromDateExport ? moment(userCredit.defaultSearchFromDateExport).toDate() : moment(userCredit.searchFromDateExports).toDate();
      }
    }
  } else if (new URLSearchParams(searchString).get("comingFrom") === redirectionTypeEnum.email) {
    tempDate = fromActualArrivalDate;
  } else {
    tempDate = moment(orignalFromDate).toDate();
  }
  return tempDate;
};
export const categoryNameChecker = (filterMapList, countryType) => {
  if (!!filterMapList && filterMapList.length) {
    let categoryNameClone = { ...categoryName };
    let filterMapListClone = JSON.parse(JSON.stringify(filterMapList));
    Object.keys(categoryName).forEach((item) => {
      let val = filterMapListClone.filter((val) => val.categoryName === item);
      if (val.length === 0) {
        delete categoryNameClone[item];
      }
    });
    if (countryType && hasOwn(categoryNameClone, getObjectKeyByValue(categoryNameClone, categoryName.shipperDetails)) && (countryType.toLowerCase() === "import" || countryType.toLowerCase() === "imports")) {
      delete categoryNameClone.shipperDetails;
      categoryNameClone = { ...{ shipperDetails: categoryName.shipperDetails }, ...categoryNameClone };
    }
    return categoryNameClone;
  }
};
export const mapYearDatesInCalendar = function (isAdd, date, latestArrivalDate) {
  let yearDifference = new Date(date).getFullYear() - new Date(latestArrivalDate).getFullYear();
  let thisYear = new Date(date).getFullYear();
  let startDate = new Date("1/1/" + thisYear);
  let firstDateOfyear = moment.utc(startDate.valueOf());
  let tempReturnObject = {};
  if (isAdd === true) {
    tempReturnObject = {
      "Last 1 Month": [moment.utc(new Date(date)).subtract(1, "month").add("1", "days").toDate(), moment.utc(new Date(date)).add("1", "days").toDate()],
      "Last 3 Months": [moment.utc(new Date(date)).subtract(3, "month").add("1", "days").toDate(), moment.utc(new Date(date)).add("1", "days").toDate()],
      "Year to Date": [firstDateOfyear.toDate(), moment.utc(new Date(date)).add("1", "days").toDate()],
      "Last 1 Year": [moment.utc(new Date(date)).subtract(1, "year").add("2", "days").toDate(), moment.utc(new Date(date)).add("1", "days").toDate()],
      "Last 2 Years": [moment.utc(new Date(date)).subtract(2, "year").add("2", "days").toDate(), moment.utc(new Date(date)).add("1", "days").toDate()],
    };
    if (yearDifference > 2) {
      tempReturnObject["Last 3 Years"] = [moment.utc(new Date(date)).subtract(3, "year").add("2", "days").toDate(), moment.utc(new Date(date)).add("1", "days").toDate()];
    }
    tempReturnObject["All Data"] = [moment.utc(new Date(latestArrivalDate)).add("1", "days").toDate(), moment.utc(new Date(date)).add("1", "days").toDate()];
  } else {
    tempReturnObject = {
      "Last 1 Month": [moment.utc(new Date(date)).subtract(1, "month").toDate(), moment.utc(new Date(date)).toDate()],
      "Last 3 Months": [moment.utc(new Date(date)).subtract(3, "month").toDate(), moment.utc(new Date(date)).toDate()],
      "Year to Date": [firstDateOfyear.toDate(), moment.utc(new Date(date)).add("1", "days").toDate()],
      "Last 1 Year": [moment.utc(new Date(date)).subtract(1, "year").add("1", "days").toDate(), moment.utc(new Date(date)).toDate()],
      "Last 2 Years": [moment.utc(new Date(date)).subtract(2, "year").add("2", "days").toDate(), moment.utc(new Date(date)).add("1", "days").toDate()],
    };
    if (yearDifference > 2) {
      tempReturnObject["Last 3 Years"] = [moment.utc(new Date(date)).subtract(3, "year").add("1", "days").toDate(), moment.utc(new Date(date)).toDate()];
    }
    tempReturnObject["All Data"] = [moment.utc(new Date(latestArrivalDate)).toDate(), moment.utc(new Date(date)).toDate()];
  }

  return tempReturnObject;
};
export const mapMonthObject = (date, fromDate, actualFromDate) => {
  // fromDate = 2020 , date = 2025,
  // actualFromDate = 2018
  let tempObject = {
    actualFromDate: actualFromDate,
    actualFromYear: actualFromDate.split("-")[0],
    actualFromMonth: "" + actualFromDate.split("-")[1],
    actualToDate: date,
    actualToYear: date.split("-")[0],
    actualToMonth: "" + date.split("-")[1],
    rangeValue: {
      from: {
        year: +actualFromDate.split("-")[0],
        month: +actualFromDate.split("-")[1],
      },
      to: {
        year: +date.split("-")[0],
        month: +date.split("-")[1],
      },
    },
  };
  return tempObject;
};
export const getTotalCount = (label, filterMapList, appliedStateFilterObject, searchedProximityFilterData, specialTooltipKeywords, appliedBooleanFilterObject, appliedBoxFilterObj, defaultBoxFilterObj) => {
  let obj = {};
  filterMapList.map((val) => {
    if (appliedStateFilterObject[val.key]) {
      if (obj[val.categoryName]) {
        obj[val.categoryName] += appliedStateFilterObject[val.key].length;
      } else {
        obj[val.categoryName] = appliedStateFilterObject[val.key].length;
      }
      if (!!appliedBooleanFilterObject && typeof appliedBooleanFilterObject[val.key] === "boolean" && !appliedBooleanFilterObject[val.key]) {
        obj[val.categoryName] = 0;
        obj[val.categoryName] += 1;
      }
      if (appliedBoxFilterObj && defaultBoxFilterObj && defaultBoxFilterObj[val.key] && appliedBoxFilterObj[val.key] && appliedBoxFilterObj[val.key].length) {
        if (JSON.stringify(defaultBoxFilterObj[val.key]) !== JSON.stringify(appliedBoxFilterObj[val.key])) {
          if (obj[val.categoryName]) {
            obj[val.categoryName] += 2;
          } else {
            obj[val.categoryName] = 2;
          }
        }
      }
    }
    if (appliedStateFilterObject[val.additionalKey]) {
      if (obj[val.categoryName]) {
        obj[val.categoryName] += appliedStateFilterObject[val.additionalKey].length;
      } else {
        obj[val.categoryName] = appliedStateFilterObject[val.additionalKey].length;
      }
    }
  });
  return obj[label];
};
export const clearMainFilter = (label, filterMapList, clearIndividualFilter, filterTypeEnum, excludedFilter, callingSearchApi) => {
  let filteredList = filterMapList.filter((item) => item.categoryName === label);
  for (let i = 0; i < filteredList.length; i++) {
    setTimeout(() => {
      if (Object.keys(excludedFilter).length === 0 || excludedFilter[filterTypeEnum[filteredList[i].key]] === undefined) {
        clearIndividualFilter(filterTypeEnum[filteredList[i].key], "clearmain", filteredList.length === i + 1);
      }
    }, i * 100);
  }
  callingSearchApi();
};
export const parentToolTip = (appliedStateFilterObject, selectedFilterList, searchedProximityFilterData, specialTooltipKeywords, appliedBooleanFilterObject, includeArray, excludeArray, filterObject) => {
  let string = "";
  selectedFilterList.map((item) => {
    if (appliedStateFilterObject[item.key] && Array.isArray(appliedStateFilterObject[item.key])) {
      if (appliedStateFilterObject[item.key].length) {
        string += "//" + item.label;
        if (includeArray.includes(item.key)) string += " Including";
        else if (excludeArray.includes(item.key)) string += " Excluding";
        string += ";;";
      }
      if (appliedStateFilterObject[item.key] && Array.isArray(appliedStateFilterObject[item.key])) {
        appliedStateFilterObject[item.key].map((val) => {
          let stringData = "";
          if (filterObject[item.key]?.length) {
            let data = filterObject[item.key].find((el) => el.key === val);
            if (data) {
              if (data?.region) {
                stringData = data?.region?.map((region) => region?.description || region?.key).join("");
                val = stringData;
              } else if (data?.value) {
                stringData = data?.values?.map((region) => region?.description || region?.key).join("");
                val = stringData;
              } else {
                if (item.key === "hsCode") {
                  val = data?.key;
                } else {
                  val = data?.description || data?.key;
                }
              }
            }
          }
          if (item.type === filterType.multiSelectRangeFilter) {
            val = val?.key?.toLowerCase() + " : " + commaFormat(val?.range?.[0]) + " to " + commaFormat(val?.range?.[1]);
          }
          val = val.toString();
          string += val.includes("$$") ? (showNoDollar[item.key] ? val.split("$$")[1] : val.split("$$")[0] + "|") : val + "|";
        });
      }
      if (!!appliedBooleanFilterObject && typeof appliedBooleanFilterObject[item.key] === "boolean" && !appliedBooleanFilterObject[item.key]) {
        string += "//" + item.label + ";;";
        if (item.key === "is_enriched_data") {
          string += "Partial & Complete Bill of Lading |";
        } else {
          string += "INCLUDE|";
        }
      }
    }
    if (appliedStateFilterObject[item.additionalKey] && Array.isArray(appliedStateFilterObject[item.additionalKey])) {
      if (appliedStateFilterObject[item.additionalKey].length) {
        string += "//" + item.label;
        if (includeArray.includes(item.additionalKey)) string += " Including";
        else if (excludeArray.includes(item.additionalKey)) string += " Excluding";
        string += ";;";
      }
      if (appliedStateFilterObject[item.additionalKey] && Array.isArray(appliedStateFilterObject[item.additionalKey])) {
        appliedStateFilterObject[item.additionalKey].map((val) => {
          if (item.additionalType === "multiSelectRangeFilter") {
            val = val?.key?.toLowerCase() + " : " + commaFormat(val?.range?.[0]) + " to " + commaFormat(val?.range?.[1]);
          }
          val = val.toString();
          string += val.includes("$$") ? (showNoDollar[item.additionalKey] ? val.split("$$")[1] : val.split("$$")[0] + "|") : val + "|";
        });
      }
    }
  });
  return string;
};
// Below Method is used for converting first letter of every work to capitals
export const getFirstLetterCapital = function (str) {
  if (str === "US IMPORTS" || str === "US EXPORTS") {
    return getTitleCase(str) + " (Maritime)";
  }
  if (str) {
    let splitStr = str.toLowerCase().split(" ");
    for (let i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(" ");
  }
};
// End of above code
const mapCurrentPlanOfUser = function (str = "") {
  if (str.includes(trackingPlanEnum.free.key) === true) {
    return trackingPlanEnum.free.value;
  } else if (str.includes(trackingPlanEnum.basic.key) === true) {
    return trackingPlanEnum.basic.value;
  } else if (str.includes(trackingPlanEnum.essential.key) === true) {
    return trackingPlanEnum.essential.value;
  } else if (str.includes(trackingPlanEnum.plus.key) === true) {
    return trackingPlanEnum.plus.value;
  } else if (str.includes(trackingPlanEnum.starter.key) === true) {
    return trackingPlanEnum.starter.value;
  } else if (str.includes(trackingPlanEnum.advanced.key) === true) {
    return trackingPlanEnum.advanced.value;
  } else if (str.includes(trackingPlanEnum.enterprise.key) === true) {
    return trackingPlanEnum.enterprise.value;
  } else if (str.includes(trackingPlanEnum.proLite.key) === true) {
    return trackingPlanEnum.proLite.value;
  } else if (str.includes(trackingPlanEnum.pro2.key) === true) {
    return trackingPlanEnum.pro2.value;
  } else if (str.includes(trackingPlanEnum.pro.key) === true) {
    return trackingPlanEnum.pro.value;
  } else {
    return trackingPlanEnum.unknown.value;
  }
};

// Below Method is used for Generating the Tracking Object
export const generateTrackingObject = function (dataSource, urlData, planData, accessType) {
  // Below Object is used for Tracking the User Events
  let planID = localStorageService && localStorageService.getUserCurrentPlan() ? localStorageService.getUserCurrentPlan() : "";
  let url = window.location.pathname;
  let returnObject = {
    dataSource: dataSource,
    urlData: url ? url : urlData,
    plan: planID ? mapCurrentPlanOfUser(planID) : mapCurrentPlanOfUser(planData),
    accessType: accessType,
  };
  // End of the above object
  return returnObject;
};
// End of above code
// Below Method is used for Checking the Company Redirection
export const globalPendoEventForCompanyRedirection = function (event, isRedirect, redirectingCompanyExporterId, redirectingCompanyImporterId, redirectingCompanyLogisticsId, dataSource, pathName, currentUserPlan, redirectionHsCodeValue) {
  let tempEvent = "";
  const searchUrlParams = window.location.search;
  for (let [key, value] of Object.entries(trackingEventDictionary)) {
    if (event && key && value === event) {
      tempEvent = key;
    }
  }
  if (!!tempEvent && tempEvent.length !== 0 && tempEvent[0] !== "" && redirectionHsCodeValue) {
    tempEvent = "hsCodeRedirection" + tempEvent[0].toUpperCase() + tempEvent.slice(1);
  } else if (!!tempEvent && tempEvent.length !== 0 && tempEvent[0] !== "") {
    tempEvent = "companyRedirection" + tempEvent[0].toUpperCase() + tempEvent.slice(1);
  }
  if (tempEvent && trackingEventDictionary && trackingEventDictionary[tempEvent] && isRedirect && (redirectingCompanyExporterId || redirectingCompanyImporterId || redirectingCompanyLogisticsId || redirectionHsCodeValue)) {
    let redirectionFrom = new URLSearchParams(searchUrlParams).get("redirectingFrom");
    let event = trackingEventDictionary[tempEvent];
    if (redirectionFrom === profileTypeEnum.tradeLanes) {
      event = event.replace("company", "tradelane");
    } else if (redirectionFrom === profileTypeEnum.ports) {
      event = event.replace("company", "ports");
    } else if (redirectionFrom === profileTypeEnum.logistics) {
      event = event.replace("company", "logistics_company");
    }
    trademoTrackingEvents(event, generateTrackingObject(dataSource, pathName, currentUserPlan));
  } else {
    trademoTrackingEvents(event, generateTrackingObject(dataSource, pathName, currentUserPlan));
  }
};
// End of the above code
// Below Method builds a per-filter tracking event name from the filter label
export const buildFilterTrackingEvent = function (label, action) {
  const sanitizedLabel = String(label ?? "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
  return sanitizedLabel ? `filter_${sanitizedLabel}_${action}` : "";
};
// End of the above code
export const createCountryRedirectUrl = (countryName, tradeDirection) => {
  if (!countryName) return globalCountryDetailsDictionary.multi_country.countryPathName;
  if (countryName === globalCountryDetailsDictionary.multi_country.countryCode) {
    return globalCountryDetailsDictionary.multi_country.countryPathName;
  }
  if (countryName === globalCountryDetailsDictionary.global_plan.countryCode) {
    return globalCountryDetailsDictionary.global_plan.countryPathName;
  }
  if (!tradeDirection) return;
  if (countryName === globalCountryDetailsDictionary.ch_import.countryCodeFlag.toLowerCase() && tradeDirection.toLowerCase() === globalCountryDetailsDictionary.ch_import.manyCountryType) {
    return globalCountryDetailsDictionary.ch_import.countryPathName;
  } else if (countryName === globalCountryDetailsDictionary.ch_export.countryCodeFlag.toLowerCase() && tradeDirection.toLowerCase() === globalCountryDetailsDictionary.ch_export.manyCountryType) {
    return globalCountryDetailsDictionary.ch_export.countryPathName;
  }
  if (countryName === globalCountryDetailsDictionary.uk_import.countryCodeFlag.toLowerCase() && tradeDirection.toLowerCase() === globalCountryDetailsDictionary.ch_import.manyCountryType) {
    return globalCountryDetailsDictionary.uk_import.countryPathName;
  } else if (countryName === globalCountryDetailsDictionary.uk_export.countryCodeFlag.toLowerCase() && tradeDirection.toLowerCase() === globalCountryDetailsDictionary.ch_export.manyCountryType) {
    return globalCountryDetailsDictionary.uk_export.countryPathName;
  }
  const dataSource = countryName?.toLowerCase() + "_" + tradeDirection?.slice(0, -1).toLowerCase();
  return globalCountryDetailsDictionary[dataSource].countryPathName;
};

export const getRedirectProfileType = (category) => {
  for (const [key, value] of Object.entries(redirectionTypePayload)) {
    if (value === category) {
      return key;
    }
  }
  return category;
};

export const childToolTip = (shipmentDetails, val) => {
  if (Array.isArray(shipmentDetails.appliedFilter[val.key]) || Array.isArray(shipmentDetails.appliedFilter[val?.additionalKey])) {
    let filterStringsArr = [];
    filterStringsArr = shipmentDetails.appliedFilter[val.key].map((item) => {
      let filterString = "";
      if (shipmentDetails.filterObject[val.key]?.length > 0) {
        const filterFound = shipmentDetails.filterObject[val.key].find((filterItem) => filterItem.key === item);
        if (filterFound) {
          if (filterFound.region) {
            filterFound.region.forEach((item3) => {
              if (item3.key === item) {
                filterString = (item3?.description && typeof item3.description === "string" && !item3.description.includes(multiplyIdentifier) && item3.description) || item3?.key;
              }
            });
          } else if (filterFound.key === item) {
            filterString = filterFound.description ?? filterFound.key ?? item;
          }
        }
      }
      if (val.type === filterType.multiSelectRangeFilter) {
        filterString = item?.key?.toLowerCase() + " : " + commaFormat(item?.range?.[0]) + " to " + commaFormat(item?.range?.[1]);
      }
      filterString = filterString.toString() || item.toString();
      return filterString.includes("$$") ? (showNoDollar[val.key] ? filterString.split("$$")[1] : filterString.split("$$")[0]) : filterString;
    });
    if (shipmentDetails?.appliedFilter[val?.additionalKey]?.length) {
      filterStringsArr = shipmentDetails.appliedFilter[val?.additionalKey].map((item) => {
        let filterString = "";
        if (val.additionalType === "multiSelectRangeFilter") {
          filterString = item?.key?.toLowerCase() + " : " + commaFormat(item?.range?.[0]) + " to " + commaFormat(item?.range?.[1]);
        }
        filterString = filterString.toString();
        return filterString.includes("$$") ? (showNoDollar[val.additionalKey] ? filterString.split("$$")[1] : filterString.split("$$")[0]) : filterString;
      });
    }
    return filterStringsArr.join(" | ");
  } else if (shipmentDetails.filterObject[val.key]) {
    let filterString = "";
    filterString = shipmentDetails.filterObject[val.key] ? "Including" : "Excluding";
    return filterString;
  }
  return "";
};
